import { NotFoundException } from '@nestjs/common';

export class UnknownNotificationMessengerServiceParameterException extends NotFoundException {
  constructor(value: string) {
    super();

    this.message = `Unknown NOTIFICATION_MESSENGER_SERVICE environment parameter: ${value}.`;
  }
}
